import * as React from "react";
import { ChildInfoMatch } from "./ChildInfoMatch";
import MatchDetail from "../../BoundingBox/MatchDetail";
import { IMatch } from "src/share/types/match";
import usePhotoViewer from "src/share/components/PhotoViewer/usePhotoViewer";

export interface IAdhocMatchesProps {
  matches: IMatch[];
  deleteMatch?: (matchId) => () => void;
  deleting: boolean;
}

const AdhocMatches = ({ matches, deleteMatch, deleting }) => {
  const { handleZoomInImage } = usePhotoViewer();
  return (
    matches.map(matchData => (
      <div className="matches-container">
        {matchData.caseInfo && matchData.childInfo && <ChildInfoMatch caseInfo={matchData.caseInfo} childInfo={matchData.childInfo} />}
        <div key={matchData.matchId} className="match-info white-background">
          <MatchDetail match={matchData} deleteMatch={deleteMatch} deleting={deleting} onZoomImage={handleZoomInImage} />
        </div>
      </div>
    ))
  )
};

export default React.memo(AdhocMatches);



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/components/AdhocMatches.tsx